import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloat({ phone = "+33644660033", message = "Bonjour MYDORITECH, j'ai une question." }) {
  const cleaned = phone.replace(/[^0-9]/g, "");
  const url = `https://wa.me/${cleaned}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Contact WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-brand-green animate-pulse-green" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-brand-green text-black shadow-glow-green hover:scale-110 transition-transform duration-200">
        <FaWhatsapp className="h-7 w-7" />
      </span>
    </a>
  );
}
